import { ReactNode } from 'react';

import { Box, Button, HStack, Text, useClipboard } from '@chakra-ui/react';

import { DynamicCopyIcon } from 'components/uikit/CopyWrapper';

interface PaymentFieldRowProps {
  label: string;
  value: string;
  displayedValue?: ReactNode;
  showCopy?: boolean;
  customClass?: string;
  onCopyFunc?: () => void;
}

export function PaymentFieldRow({
  label,
  value,
  displayedValue,
  showCopy = true,
  customClass = '',
  onCopyFunc = () => null,
}: PaymentFieldRowProps) {
  const { onCopy, hasCopied } = useClipboard(value);

  return (
    <HStack
      align='center'
      gap='12px'
      justifyContent='space-between'
      flexWrap='wrap'
      rowGap='0'
      w='100%'
      py='10px'
    >
      <Text fontSize='md' color='grey.tertiaryText' fontWeight='medium'>
        {label}
      </Text>
      {showCopy ? (
        <Button
          bg='transparent'
          color='grey.primaryText'
          cursor='pointer'
          borderRadius='8px'
          px='12px'
          py='8px'
          h='auto'
          maxW='100%'
          whiteSpace='normal'
          textAlign='start'
          _hover={{ bg: 'transparent' }}
          onClick={(e) => {
            e.stopPropagation();
            onCopyFunc();
            onCopy();
          }}
          aria-label={`Copy ${label}`}
          type='button'
          gap='8px'
          className={customClass}
        >
          <Text
            fontSize='xl'
            color='grey.primaryText'
            fontWeight='medium'
            wordBreak='break-word'
          >
            {displayedValue ?? value}
          </Text>
          <DynamicCopyIcon
            hasCopied={hasCopied}
            boxSize='18px'
            color={hasCopied ? 'success.button' : 'grey.primaryText'}
          />
        </Button>
      ) : (
        <Box>
          {displayedValue ? (
            displayedValue
          ) : (
            <Text fontSize='md' color='grey.primaryText' fontWeight='medium'>
              {value}
            </Text>
          )}
        </Box>
      )}
    </HStack>
  );
}
